/**
 * ポップアップ ユーティリティ クラス。
 */
export default class ConfigUtils {
  /**
   * 指定されたキーに対応する設定値を取得します。
   *
   * @param {string} key - 設定のキー
   * @returns {any} - キーに対応する設定値、存在しない場合は null
   */
  static getConfigByKey(key) {
    // eslint-disable-next-line no-undef
    return config[key] || null
  }
}



// WEBPACK FOOTER //
// ./src/common/config-utils.js